import {
  getBaseProductColorFacesInMaker,
  getItsSf,
  getRealFcanvass,
  getSelfCanvasZoomWrapper,
} from '../getSth.js';
import { createFcanvas } from '../util.js';
import { find, go, sel, each, ippL } from 'fxjs/es';
import { resetBgWithoutCvMaskBySf, resetCvMaskBySf } from '../SizeFaces/fs.js';
import { makeCvBpcfInMakerA } from '../CvBpcf/fs.js';
import { $qs, $qsa } from 'fxdom/es';
const requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame;
const cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;

function cvObjs(canvas) {
  return canvas ? canvas._objects : [];
}

function findCvBpcfVideo(fcanvas) {
  return find(function (obj) {
    return obj._data.cv_type == 'cv_bpcf_video';
  }, cvObjs(fcanvas));
}
function findCvBpcfVideoMask(canvas) {
  return find(function (obj) {
    return obj._data.cv_type == 'cv_bpcf_video_mask';
  }, cvObjs(canvas));
}

export const hasVideoUrl = function () {
  return !!getBaseProductColorFacesInMaker()[0].video_url;
};

function makeCvBpcfVideo(canvas, bpcf_video_url, sf, mp_maker_video_el) {
  /*비디오 하나일때, 면이 하나일때만 올바르게 동작*/
  const last_cv_bpcf_video = findCvBpcfVideo(canvas);
  if (last_cv_bpcf_video) canvas.remove(last_cv_bpcf_video);

  const cv_bpcf_video = new fabric.Image(mp_maker_video_el, {
    visible: false,
    objectCaching: false,
    selectable: false,
    evented: false,
    globalCompositeOperation: 'destination-over',
    _data: { cv_type: 'cv_bpcf_video', is_not_design: true },
  });
  canvas.add(cv_bpcf_video);
  resetBgWithoutCvMaskBySf(cv_bpcf_video, sf);
  if (!bpcf_video_url) return;
  if (G.mp.maker.is_ie || !mp_maker_video_el || !mp_maker_video_el.play || !requestAnimationFrame) return;
  mp_maker_video_el.src = bpcf_video_url + G.mp.maker.cross_origin_query_str;
  playCvBpcfVideoAni(mp_maker_video_el);
}

function makeCvBpcfVideoMask(canvas, bpcf_mask2_url, sf) {
  const last_cv_bpcf_video_mask = findCvBpcfVideoMask(canvas);
  if (last_cv_bpcf_video_mask) canvas.remove(last_cv_bpcf_video_mask);
  return new Promise(function (resolve) {
    fabric.Image.fromURL(G.mp.maker.url(bpcf_mask2_url), function (img) {
      img.set({
        selectable: false,
        evented: false,
        globalCompositeOperation: 'destination-in',
        _data: { cv_type: 'cv_bpcf_video_mask', is_not_design: true },
      });
      img.set({ visible: !!bpcf_mask2_url });
      canvas.add(img);
      resetCvMaskBySf(img, sf);
      canvas.renderAll();
      resolve();
    });
  });
}

export function disposeVideo() {
  go(
    $qsa('.mp_maker_video'),
    each((mp_maker_video_el) => {
      const cv_bpcf_video_data = sel('_cv_bpcf_video_data', mp_maker_video_el);
      if (!cv_bpcf_video_data) return;
      if (cv_bpcf_video_data.raf) {
        cancelAnimationFrame(cv_bpcf_video_data.raf);
        cv_bpcf_video_data.raf = null;
      }
      if (cv_bpcf_video_data.fcanvas) {
        const fcanvas = cv_bpcf_video_data.fcanvas;
        $.prepend(fcanvas.wrapperEl, fcanvas.lowerCanvasEl);
        fcanvas.dispose();
        cv_bpcf_video_data.fcanvas = null;
      }
    }),
  );
}

async function initVideo(bpcf, sf, f_canvas, idx) {
  const f_canvas_for_video = createFcanvas();
  const zoom_wrapper = getSelfCanvasZoomWrapper(f_canvas);
  go(f_canvas_for_video.lowerCanvasEl, $.prepend_to(zoom_wrapper));
  const mp_maker_video_el = $('.mp_maker_video')[idx];
  mp_maker_video_el._cv_bpcf_video_data = {
    raf: null,
    fcanvas: f_canvas_for_video,
  };
  await makeCvBpcfInMakerA(f_canvas_for_video, bpcf, sf);
  await makeCvBpcfVideo(f_canvas_for_video, bpcf.video_url, sf, mp_maker_video_el);
  await makeCvBpcfVideoMask(f_canvas_for_video, bpcf.mask2_url, sf);
  const cv_bpcf = G.mp.maker.cv_bpcf(f_canvas_for_video);
  cv_bpcf.bringToFront();
}

export async function dealWithVideoUrl() {
  if (G.mp.maker.is_ie) return;
  disposeVideo();
  await go(
    getRealFcanvass(),
    ippL,
    each(async ([idx, f_canvas]) => {
      const bpcf = getBaseProductColorFacesInMaker().find(
        (bpcf) => bpcf.base_product_face_id === f_canvas.bpf_id,
      );

      if (bpcf.video_url) {
        G.mp.maker.cv_bpcf(f_canvas).visible = false;
        const sf = getItsSf(f_canvas);
        await initVideo(bpcf, sf, f_canvas, idx);
      }
      f_canvas?.renderAll();
    }),
  );
}

export function playCvBpcfVideoAni(mp_maker_video_el) {
  const cv_bpcf_video_data = sel('_cv_bpcf_video_data', mp_maker_video_el);
  if (!cv_bpcf_video_data) return;
  if (cv_bpcf_video_data.raf) return;
  try {
    const fcanvas = cv_bpcf_video_data.fcanvas;
    const cv_bpcf_video = findCvBpcfVideo(fcanvas);
    mp_maker_video_el
      .play()
      .then(() => {
        cv_bpcf_video.visible = true;
        requestAnimationFrame(function render() {
          if (
            G.mp.maker.active() ||
            $qs('.mp_maker .decoration_menu.decoration_mode') ||
            $qs('.don_frame.maker_sticker_frame') ||
            $qs('html.clear_maker_canvas') ||
            $qs('html.all_faces_mode')
          ) {
            mp_maker_video_el.pause();
          } else {
            mp_maker_video_el.play().catch(() => '');
            fcanvas.renderAll();
          }
          cv_bpcf_video_data.raf = requestAnimationFrame(render);
        });
      })
      .catch(() => {});
  } catch (e) {}
}
